<template>
    <div class="d-flex w-100 bg-light py-1 ps-3 border-bottom">

        <views-dropdown :table="table" :view="view"></views-dropdown>

        <filter-dropdown :table="table" :view="view"></filter-dropdown>

        <sort-dropdown :table="table" :view="view"></sort-dropdown>

        <view-options-dropdown :table="table" :view="view"></view-options-dropdown>

        <table-dropdown :table="table" :view="view"></table-dropdown>

    </div>

</template>

<script>
    import ViewOptionsDropdown from "./ViewOptionsDropdown.vue"
    import ViewsDropdown from "./ViewsDropdown.vue";
    import SortDropdown from "./SortDropdown.vue";
    import FilterDropdown from "./FilterDropdown.vue";
    import ConfirmModal from "../../components/ConfirmModal.vue";
    import TableDropdown from "./TableDropdown.vue";

    export default {
        name: 'ViewToolbar',
        components: {
            TableDropdown, ConfirmModal, FilterDropdown, SortDropdown, ViewsDropdown, ViewOptionsDropdown
        },
        props: ['table', 'view'],
        data () {
            return {
                model: webase.model
            }
        }
    }
</script>

<style>

</style>
